const baseURL = 'https://mitiendaoch.com/';

export default baseURL;
